// tracker-events.js - Event tracking methods
// Extends ShopifyBehavioralTracker with event methods

ShopifyBehavioralTracker.prototype.viewContent = function (productId, productName = '', category = '', price = 0, currency = 'EGP') {
    this.track('view_content', {
        content_type: 'product',
        content_ids: [productId],
        content_name: productName,
        content_category: category,
        value: parseFloat(price),
        currency: currency,
        product_id: productId,
        product_name: productName,
        product_price: parseFloat(price),
        product_category: category,
        page_type: 'product',
        referrer: document.referrer,
        user_agent: navigator.userAgent.substring(0, 100), // Truncated
        device_type: this.getDeviceType()
    });
};

ShopifyBehavioralTracker.prototype.addToCart = function (productId, productName = '', category = '', price = 0, quantity = 1, currency = 'USD') {
    this.track('add_to_cart', {
        content_type: 'product',
        content_ids: [productId],
        content_name: productName,
        content_category: category,
        value: parseFloat(price) * parseInt(quantity),
        currency: currency,
        quantity: parseInt(quantity)
    });
};

ShopifyBehavioralTracker.prototype.initiateCheckout = function (value = 0, currency = 'USD', items = []) {
    this.track('initiate_checkout', {
        value: parseFloat(value),
        currency: currency,
        num_items: items.length,
        content_ids: items.map(item => item.id),
        contents: items
    });
};

// Add purchase tracking method to the prototype
ShopifyBehavioralTracker.prototype.purchase = function (orderId, total, currency = 'USD', items = []) {
    this.track('purchase', {
        order_id: orderId,
        total_amount: parseFloat(total),
        currency: currency,
        item_count: items.length,
        items: items,
        avg_item_price: items.length > 0 ? total / items.length : 0,
        total_quantity: items.reduce((sum, item) => sum + (item.quantity || 1), 0)
    });
};

// ===========================================
// BEHAVIORAL EVENTS (Custom for Your Business)
// ===========================================

ShopifyBehavioralTracker.prototype.sustainabilityEngaged = function (timeSpent = 0, pageSection = '') {
    this.track('sustainability_engaged', {
        time_spent: parseInt(timeSpent),
        page_section: pageSection,
        engagement_level: timeSpent > 120 ? 'high' : timeSpent > 30 ? 'medium' : 'low'
    });
};

ShopifyBehavioralTracker.prototype.soilToSoilEngaged = function (timeSpent = 0, pageSection = '') {
    this.track('soil_to_soil_engaged', {
        time_spent: parseInt(timeSpent),
        page_section: pageSection,
        engagement_level: timeSpent > 120 ? 'high' : timeSpent > 30 ? 'medium' : 'low'
    });
};

ShopifyBehavioralTracker.prototype.priceFocused = function (trigger = '', currentPage = '') {
    this.track('price_focused', {
        trigger: trigger,
        current_page: currentPage,
        behavior_type: 'price_sensitive'
    });
};

ShopifyBehavioralTracker.prototype.highProductEngagement = function (productId, timeSpent = 0) {
    this.track('high_product_engagement', {
        product_id: productId,
        time_spent: parseInt(timeSpent),
        engagement_type: 'deep_view'
    });
};

ShopifyBehavioralTracker.prototype.multipleProductViews = function (count, browsingType = 'browser', sessionDuration = 0) {
    this.track('multiple_product_views', {
        view_count: parseInt(count),
        session_id: this.sessionId,
        behavior_type: browsingType,
        session_duration_seconds: sessionDuration,
        browsing_pattern: count >= 8 ? 'extensive' : count >= 5 ? 'heavy' : 'standard'
    });
};

ShopifyBehavioralTracker.prototype.emailCaptured = function (email, source = '') {
    this.track('email_captured', {
        email: email,
        source: source,
        capture_type: 'email_signup'
    });

    // Identify user with email
    this.identify(email);
};

ShopifyBehavioralTracker.prototype.searchPerformed = function (query) {
    this.track('search_performed', {
        query: query,
        search_type: 'site_search'
    });
};

ShopifyBehavioralTracker.prototype.videoWatched = function (videoTitle, percentComplete, duration = null) {
    let eventName = 'video_watched';
    if (percentComplete >= 25 && percentComplete < 50) eventName = 'video_watched_25';
    else if (percentComplete >= 50 && percentComplete < 75) eventName = 'video_watched_50';
    else if (percentComplete >= 75 && percentComplete < 100) eventName = 'video_watched_75';
    else if (percentComplete >= 100) eventName = 'video_completed';

    this.track(eventName, {
        video_title: videoTitle,
        percent_complete: parseInt(percentComplete),
        video_duration: duration ? parseInt(duration) : null
    });
};

ShopifyBehavioralTracker.prototype.socialProofEngaged = function (type = 'reviews', productId = null) {
    this.track('social_proof_engaged', {
        type: type,
        product_id: productId,
        engagement_type: 'social_proof'
    });
};



ShopifyBehavioralTracker.prototype.pageVisit = function (pageType, pageName = '', visitCount = 1, visitTimestamps = []) {
    // Get enhanced scroll data
    const scrollData = window.scrollData || { maxScrollReached: 0, currentScroll: 0 };
    const maxScroll = scrollData.maxScrollReached;
    const currentScroll = scrollData.currentScroll;

    let scrollCategory = 0;
    if (maxScroll >= 100) scrollCategory = 100;
    else if (maxScroll >= 75) scrollCategory = 75;
    else if (maxScroll >= 50) scrollCategory = 50;
    else if (maxScroll >= 25) scrollCategory = 25;

    // Calculate time between visits if multiple visits
    let timeBetweenVisits = 0;
    if (visitTimestamps.length > 1) {
        const lastVisit = visitTimestamps[visitTimestamps.length - 2];
        const currentVisit = visitTimestamps[visitTimestamps.length - 1];
        timeBetweenVisits = Math.floor((currentVisit - lastVisit) / 1000); // seconds
    }

    this.track('page_visit', {
        page_type: pageType,
        page_name: pageName,
        page_url: window.location.href,
        page_path: window.location.pathname,
        page_query: window.location.search,
        visit_count: visitCount,
        visit_timestamps: visitTimestamps,
        time_since_last_visit: timeBetweenVisits,
        max_scroll_reached: maxScroll,
        current_scroll_position: currentScroll,
        scroll_category: scrollCategory,
        page_height: Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight
        ),
        viewport_height: window.innerHeight,
        is_return_visit: visitCount > 1
    });
};


